import { IEmail, IEmailTemplate } from '../../interfaces/email-template';
import { EmailService } from './../../services';
import { EmailTemplateService } from '../../services';
import { Component, OnInit } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { BBWTMessageService } from '../../services';

@Component({
  selector: 'email-template-test',
  templateUrl: './email-template-test.component.html',
})
export class EmailTemplateTestComponent implements OnInit {
  emailTemplates: IEmailTemplate[];
  email = <IEmail>{};
  subject = 'Test Email Templates';

  constructor(
    private emailTemplateService: EmailTemplateService,
    private emailService: EmailService,
    public messageService: BBWTMessageService,
  ) {}

  ngOnInit() {
    this.emailTemplateService
      .getAll()
      .then((result: IEmailTemplate[]) => {
        this.emailTemplates = result;
      })
      .catch((errorResponse: HttpErrorResponse) => {
        var message = errorResponse.error ? errorResponse.error : errorResponse.message;
        this.messageService.ShowError(this.subject, message);
      });
  }

  send() {
    this.emailService
      .sendEmail(this.email)
      .then(() => {
        this.messageService.ShowSuccess(this.subject, 'The email has been sent successfully.');
      })
      .catch((errorResponse: HttpErrorResponse) => {
        var message = errorResponse.error ? errorResponse.error : errorResponse.message;
        this.messageService.ShowError(this.subject, message);
      });
  }
}
